import { Award, AlertTriangle } from "lucide-react";
import { MONTHS_FULL_ES } from "../constants";

export const BestWorstMonth = ({ monthlyData }) => {
  if (!monthlyData || !monthlyData.months || monthlyData.months.length === 0) return null;

  const formatMonth = (monthStr) => {
    if (!monthStr) return '';
    const [year, month] = monthStr.split('-');
    return `${MONTHS_FULL_ES[parseInt(month) - 1]} ${year}`;
  };

  const best = monthlyData.best_month;
  const worst = monthlyData.worst_month;
  if (!best || !worst) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
      <div className="bg-gradient-to-br from-emerald-500/20 to-emerald-600/10 border border-emerald-500/30 rounded-xl p-5">
        <div className="flex items-center gap-3 mb-3">
          <Award className="w-6 h-6 text-emerald-400" />
          <h4 className="text-gray-400 text-sm">Mejor Mes del Año</h4>
        </div>
        <p className="text-2xl font-bold text-white mb-1">{formatMonth(best.month)}</p>
        <div className="flex items-center justify-between">
          <span className="text-emerald-400 font-semibold text-lg">+{best.total_pnl?.toFixed(2)} USDT</span>
          <span className="text-gray-400 text-sm">{best.trades} trades · {best.win_rate}% WR</span>
        </div>
      </div>
      <div className="bg-gradient-to-br from-red-500/20 to-red-600/10 border border-red-500/30 rounded-xl p-5">
        <div className="flex items-center gap-3 mb-3">
          <AlertTriangle className="w-6 h-6 text-red-400" />
          <h4 className="text-gray-400 text-sm">Peor Mes del Año</h4>
        </div>
        <p className="text-2xl font-bold text-white mb-1">{formatMonth(worst.month)}</p>
        <div className="flex items-center justify-between">
          <span className="text-red-400 font-semibold text-lg">{worst.total_pnl?.toFixed(2)} USDT</span>
          <span className="text-gray-400 text-sm">{worst.trades} trades · {worst.win_rate}% WR</span>
        </div>
      </div>
    </div>
  );
};
